import React, { ComponentType, Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";
import { ITabSetCategory } from "../../interfaces/ITabSetCategory";

export interface ICategorySliderProps {
  categories: ITabSetCategory[];
  selectedCategory: ITabSetCategory | null;
  hoveredCategory: ITabSetCategory | null;
  onMouseEnter: (category: ITabSetCategory) => void;
  onMouseLeave: (category: ITabSetCategory) => void;
}

const ClientProvider = React.lazy(
  () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "slide-outs" */
      "./categorySliderClient"
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as unknown as Promise<{ default: ComponentType<any> }>
);

const placeholder = <div className="category-slider"></div>;

const CategorySlider = (props: ICategorySliderProps) => {
  return (
    <>
      {ServerSideService.isServerSide ? (
        placeholder
      ) : (
        <Suspense fallback={placeholder}>
          <ClientProvider {...props} />
        </Suspense>
      )}
    </>
  );
};

export default CategorySlider;
